module.exports = __webpack_public_path__ + "img/tsareva.d529889d.jpg";